import { render, staticRenderFns } from "./ContactListView.vue?vue&type=template&id=ac9a3a64"
import script from "./ContactListView.vue?vue&type=script&lang=js"
export * from "./ContactListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports